import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../Tostador.css";
import { plotBackground } from "../../../config/colors";
import { TostadorFetching } from "../../../class/fetchTostador";
// Color diego #595e62

export default function PerfilAireTostador() {
  // Objeto inicial de la peticion
  const initialFetch = new TostadorFetching().setIdSeccion(4).setSecuencia(48);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  const [quemador1, setQuemador1] = useState(defaultObject);

  const [quemador2, setQuemador2] = useState(defaultObject);

  const [quemador3, setQuemador3] = useState(defaultObject);

  const [caudalFluidizacion, setCaudalFluidizacion] = useState(defaultObject);

  const [totalAireTostador, setTotalAireTostador] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateQuemador1(data);
      populateQuemador2(data);
      populateQuemador3(data);
      populateCaudalFluidizacion(data);
      populateCaudalAireTostador(data);

      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateQuemador1(data) {
    const arrValues = [];
    const arrFechas = [];

    const quemador = data.filter(
      (element) => element.Detalle === "Aire Secundario Quemador 1"
    );

    quemador.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setQuemador1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateQuemador2(data) {
    const arrValues = [];
    const arrFechas = [];

    const quemador = data.filter(
      (element) => element.Detalle === "Aire Secundario Quemador 2"
    );

    quemador.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setQuemador2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateQuemador3(data) {
    const arrValues = [];
    const arrFechas = [];

    const quemador = data.filter(
      (element) => element.Detalle === "Aire Secundario Quemador 3"
    );

    quemador.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setQuemador3({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalFluidizacion(data) {
    const arrValues = [];
    const arrFechas = [];

    const caudal = data.filter(
      (element) => element.Detalle === "Caudal de Fluidización"
    );

    caudal.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCaudalFluidizacion({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalAireTostador(data) {
    const arrValues = [];
    const arrFechas = [];

    const caudal = data.filter(
      (element) =>
        element.Detalle === "Caudal Total de Aire al Tostador (conocido)"
    );

    caudal.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalAireTostador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Aire a Tostador"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Quemador 1 --------------------------------------- */}
            <Chart.Line
              name="Aire Secundario Quemador 1"
              data={quemador1.value}
              yAxis={1}
              min={0}
              max={4000}
            />

            {/** -------------------------------- Quemador 2 --------------------------------------- */}
            <Chart.Line
              name="Aire Secundario Quemador 2"
              data={quemador2.value}
              yAxis={1}
              min={0}
              max={4000}
            />
            {/** -------------------------------- Quemador 3 --------------------------------------- */}
            <Chart.Line
              name="Aire Secundario Quemador 3"
              data={quemador3.value}
              yAxis={1}
              min={0}
              max={4000}
            />

            {/** -------------------------------- Caudal de Fluidización --------------------------------------- */}
            <Chart.Line
              name="Caudal de Fluidización"
              data={caudalFluidizacion.value}
              yAxis={0}
              min={0}
              max={40000}
            />

            {/** -------------------------------- Caudal Total de Aire al Tostador (conocido) --------------------------------------- */}
            <Chart.Line
              name="Caudal Total de Aire al Tostador (conocido)"
              data={totalAireTostador.value}
              yAxis={0}
              min={0}
              max={40000}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={quemador1.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/t"
              title="aire total - caudal de  fluidización"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={40000}
            />

            <Chart.YAxis
              labelSuffix=" Nm3/t"
              title="caudal aire secundario"
              lineWidth={2}
              lineColor="white"
              opposite={true}
            />

            <Chart.Tooltip valueSuffix=" Nm3/t" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
